import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Alert from '../components/base/Alert'
import { toggle } from '../actions/ui'
import { pollingCancel } from '../actions/polling'
import { activePollingId } from '../selectors/polling'

export function ErrorMessages({ alertFileSize, alertFileType, alertPollingId, maxFileSize, dismiss }) {
  let msg
  let dismissKey
  if (alertFileType) {
    msg = "Sorry we don't support this file type. Please try another."
    dismissKey = 'alertFileType'
  } else if (alertFileSize) {
    msg = `Your paper is too big. We can only upload papers that
      are ${maxFileSize} MB or less.`
    dismissKey = 'alertFileSize'
  } else if (alertPollingId) {
    msg = 'There was a problem uploading your paper.'
    dismissKey = alertPollingId
  }

  if (msg) {
    return <Alert type="danger" message={msg} onClose={() => dismiss(dismissKey)} />
  }
  return <span />
}

ErrorMessages.propTypes = {
  alertPollingId: PropTypes.string,
  alertFileSize: PropTypes.bool.isRequired,
  alertFileType: PropTypes.bool.isRequired,
  maxFileSize: PropTypes.number.isRequired,
  dismiss: PropTypes.func.isRequired,
}

ErrorMessages.defaultProps = {
  alertPollingId: undefined,
}

const mapStateToProps = state => ({
  alertPollingId: activePollingId(state),
  alertFileSize: state.ui.alertFileSize,
  alertFileType: state.ui.alertFileType,
  maxFileSize: state.app.upload.filesize.max / 1024 / 1024,
})

const mapDispatchToProps = dispatch => ({
  dismiss: key => {
    dispatch(toggle(key, false))
    dispatch(pollingCancel(key))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(ErrorMessages)
